import HTTPRequest from 'src/api'
import { UserInterface } from 'src/interfaces/user'

const apiPath = 'api/users'

export type IdentityCardPresignedUrlsRequest = {
  front_side_content_type: 'image/jpeg' | 'image/jpg' | 'image/png'
  back_side_content_type?: 'image/jpeg' | 'image/jpg' | 'image/png'
}

export type PresignedUrlEntry = {
  upload_url: string
  s3_key: string
}

export type IdentityCardPresignedUrlsResponse = {
  front_side: PresignedUrlEntry
  back_side: PresignedUrlEntry | null
}

export type ConfirmIdentityCardRequest = {
  front_side_card: string
  back_side_card?: string
  user_treatment_id: number
}

class automaticPlan extends HTTPRequest {
  getIdentityCardPresignedUrls(data: IdentityCardPresignedUrlsRequest) {
    return this.post<IdentityCardPresignedUrlsResponse>(
      `${apiPath}/identity-card/presigned-urls`,
      data,
    )
  }

  confirmIdentityCard(data: ConfirmIdentityCardRequest) {
    return this.post(`${apiPath}/update-identity-card`, data)
  }

  uploadHeadImage(data: any) {
    return this.post<UserInterface>(`${apiPath}/upload_head_image`, data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  }
}

export default new automaticPlan()
